import _get from 'lodash/get';

import { findAllValues } from 'utils/DICTIONARY';

export default function formatPaymentMethod(status) {
  const statusMap = findAllValues('retailerPaymentMethodChoices') || {};
  return _get(statusMap, status, '');
}
